export default __webpack_public_path__ + "static/media/paris.8be1f722.jpg";